import * as React from 'react'
import { FormProvider, useForm } from 'react-hook-form'
import { BaseTableFilters } from '@components/table/use-handle-table-filters-change'
import { CommonTableFilters, CommonTableFiltersProps } from '@components/table/common-table-filters'
import { FormSelect } from '@hyper/forms/form-select'
import { createSelectOption } from '@helpers/utils'
import { useFloorHeatingAppData } from '@modules/floor-heating/use-floor-heating-app-data'
import { ContentLoader } from '@components/content-loader'
import { CustomReactSelectOption } from '@components/custom-react-select'
import { EnhancedFloorHeatingMeasurement } from '@modules/floor-heating/models'
import { FloorHeatingTableOptions } from '@modules/floor-heating/list/floor-heating-table-options'

export type FloorHeatingListFilterParams = BaseTableFilters & { scenario: CustomReactSelectOption | null }

type Props = CommonTableFiltersProps<FloorHeatingListFilterParams> & {
  clearSelectedRows: () => void
  selectedRows: EnhancedFloorHeatingMeasurement[]
}

export const FloorHeatingListFilter: React.FC<Props> = ({
  defaultFilters,
  filters,
  setFilters,
  clearSelectedRows,
  selectedRows,
}) => {
  const methods = useForm<FloorHeatingListFilterParams>({ defaultValues: defaultFilters })
  const { appData: floorHeatingAppData, isLoading: isFetchingFloorHeatingAppData } = useFloorHeatingAppData()

  const scenariosOption = (floorHeatingAppData?.available_scenarios ?? []).map(scenario =>
    createSelectOption(scenario.name, scenario.mc_comp_id),
  )

  return (
    <FormProvider {...methods}>
      <ContentLoader isLoading={isFetchingFloorHeatingAppData}>
        <CommonTableFilters
          defaultFilters={defaultFilters}
          filters={filters}
          setFilters={setFilters}
          rowClassName="justify-content-end"
        >
          <div className="align-middle col-auto">
            <FloorHeatingTableOptions clearSelectedRows={clearSelectedRows} selectedRows={selectedRows} />
          </div>

          <FormSelect
            options={scenariosOption}
            name="scenario"
            label="Scenariusz"
            formPlainProps={{ colSize: 'auto', colStyle: { width: 260 } }}
          />
        </CommonTableFilters>
      </ContentLoader>
    </FormProvider>
  )
}
